import { Map } from 'immutable';
import { get } from 'lodash';
import errors from '../config/errors';

import {
  API_REQUEST,
  API_ERROR,
  API_SUCCESS,
  UPDATE_AUTH,
  API_STATUS_RESET
} from './action-types';

const initialState = Map({
  auth: null,
  data: null,
  error: errors.basic,
  lastQueried: null,
  isLoading: null,
  isSuccess: false,
  isAuth: false
});

const apiReducer = (state = initialState, action) => {
  switch (action.type) {
    case API_REQUEST:
      return state.set('isLoading', true).set('isSuccess', false);
    case API_SUCCESS:
      return state
        .set('data', action.payload)
        .set('isLoading', false)
        .set('isSuccess', true);
    case API_ERROR: {
      return state
        .set('isLoading', false)
        .set('isSuccess', false)
        .set('hasError', true)
        .set('error', action.error);
    }
    case API_STATUS_RESET: {
      return state
        .set('isLoading', false)
        .set('isSuccess', false)
        .set('hasError', false)
        .set('error', errors.basic);
    }
    case UPDATE_AUTH:
      return state
        .set('auth', action.payload.data.auth)
        .set('lastQueried', Date.now())
        .set('isAuth', get(action, 'payload.data.auth.expiresIn') > 0);
    default:
      return state;
  }
};

export default apiReducer;
